/* Wishlist side sheet: lists the saved pieces and lets visitors remove them */
(() => {
  const KEY = 'theme4:wishlist:id';
  const ids = () => { try { return (localStorage.getItem(KEY) || '').split(',').map((s) => s.trim()).filter(Boolean); } catch (_) { return []; } };
  const root = () => document.getElementById('dr-wishlist-sheet');
  let token = 0;

  const cache = new Map();
  const skeleton = (n) => Array.from({ length: Math.max(1, Math.min(n, 3)) }, (_, i) => {
    const r = document.createElement('div');
    r.className = 'dr-wlr dr-wlr--sk';
    r.style.setProperty('--i', i);
    r.innerHTML = '<span class="dr-wlr__img"></span><span class="dr-wlr__info"><i></i><i></i><i></i></span>';
    return r;
  });
  const parse = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return Array.from(tmp.querySelectorAll('.dr-wlr'));
  };
  const place = (list, rows, all, animate) => {
    rows.sort((a, b) => all.indexOf(a.dataset.id) - all.indexOf(b.dataset.id));
    rows.forEach((r, i) => {
      r.querySelector('.dr-wlr__rm').textContent = list.dataset.remove;
      if (animate) { r.classList.add('dr-wlr--in'); r.style.setProperty('--i', i); }
    });
    list.replaceChildren(...rows);
  };
  const load = async (wrap, all) => {
    const q = encodeURIComponent(all.map((i) => 'id:' + i).join(' OR '));
    const res = await fetch(`${wrap.dataset.search}?view=dr-wishlist&type=product&options[unavailable_products]=last&q=${q}`, { credentials: 'same-origin' });
    return res.text();
  };
  const prefetch = () => {
    const all = ids();
    const wrap = document.querySelector('#dr-wishlist-sheet .dr-wls');
    if (!wrap || !all.length || cache.has(all.join(','))) return;
    load(wrap, all).then((html) => cache.set(all.join(','), html)).catch(() => {});
  };

  const render = async () => {
    const dlg = root();
    if (!dlg) return;
    const wrap = dlg.querySelector('.dr-wls');
    const list = wrap.querySelector('.dr-wls__list');
    const empty = wrap.querySelector('.dr-wls__empty');
    const page = wrap.querySelector('.dr-wls__page');
    const all = ids();
    const key = all.join(',');
    const mine = ++token;
    if (!all.length) { list.innerHTML = ''; empty.hidden = false; page.hidden = true; return; }
    empty.hidden = true;
    page.hidden = true;
    const cached = cache.get(key);
    if (cached) {
      const rows = parse(cached);
      place(list, rows, all, true);
      page.hidden = !rows.length;
    } else {
      list.replaceChildren(...skeleton(all.length));
    }
    try {
      const html = cached && cache.get(key) === cached ? await load(wrap, all) : await load(wrap, all);
      if (mine !== token) return;
      cache.set(key, html);
      const rows = parse(html);
      if (!cached || html !== cached) place(list, rows, all, !cached);
      const none = !rows.length;
      empty.hidden = !none;
      page.hidden = none;
    } catch (_) {
      if (!cached) list.innerHTML = '';
    }
  };

  const removeId = (id, handle) => {
    const host = document.createElement('div');
    host.hidden = true;
    host.innerHTML = `<dr-core-wishlist data-id="${id}" data-handle="${handle || ''}"><svg></svg><span></span></dr-core-wishlist>`;
    /* the helper lives inside the sheet, so its click never counts as a click outside that closes the sheet */
    (root() || document.body).appendChild(host);
    const btn = host.firstElementChild;
    btn.setAttribute('action', 'remove');
    btn.click();
    host.remove();
    if (ids().includes(String(id))) {
      try { localStorage.setItem(KEY, ids().filter((i) => i !== String(id)).join(',')); } catch (_) {}
      document.dispatchEvent(new CustomEvent('theme4:wishlist:update', { bubbles: true, detail: 'the4' }));
    }
  };

  const warm = (e) => {
    if (e.target.closest && e.target.closest('[aria-controls="dr-wishlist-sheet"]')) prefetch();
  };
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('focusin', warm);
  document.addEventListener('theme4:wishlist:update', () => cache.clear());
  (window.requestIdleCallback || ((fn) => setTimeout(fn, 2500)))(prefetch);

  window.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[aria-controls="dr-wishlist-sheet"]');
    if (t && !t.matches('.dr-wlr__rm')) render();
    const rm = e.target.closest && e.target.closest('.dr-wlr__rm');
    if (rm) {
      e.preventDefault();
      e.stopPropagation();
      const row = rm.closest('.dr-wlr');
      if (!row || row.dataset.leaving) return;
      row.dataset.leaving = '1';
      removeId(rm.dataset.id, rm.dataset.handle);
      /* the row folds away smoothly, the rest of the list closes the gap; an empty list shows the empty state */
      const h = row.offsetHeight;
      const done = () => {
        row.remove();
        const list = document.querySelector('#dr-wishlist-sheet .dr-wls__list');
        if (list && !list.children.length) render();
      };
      row.style.overflow = 'hidden';
      row.style.height = h + 'px';
      void row.offsetHeight;
      row.style.transition = 'height .42s cubic-bezier(.22,1,.36,1), opacity .25s ease, padding .42s cubic-bezier(.22,1,.36,1), margin .42s cubic-bezier(.22,1,.36,1)';
      row.style.opacity = '0';
      row.style.height = '0px';
      row.style.paddingTop = '0px';
      row.style.paddingBottom = '0px';
      row.style.marginTop = '0px';
      row.style.marginBottom = '0px';
      row.style.borderWidth = '0px';
      setTimeout(done, 460);
    }
  }, true);
})();

/* Appearance switch in the account drawer (auto / light / dark); window.drTheme comes from the inline script in layout/theme.liquid */
(() => {
  const sync = () => {
    const mode = window.drTheme ? window.drTheme.get() : 'light';
    document.querySelectorAll('[data-dr-theme-set]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.drThemeSet === mode)));
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('[data-dr-theme-set]');
    if (!b || !window.drTheme) return;
    window.drTheme.set(b.dataset.drThemeSet);
    sync();
  });
  document.addEventListener('dr:theme', sync);
  sync();
  document.addEventListener('DOMContentLoaded', sync);
})();
